import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';
import { AdCreative } from '../../api/ads/ads.api';
import NativeAdCard from './native-ad-card';
import { adViewerKey } from './ad-viewer-key';

export interface CreatorAdCardProps {
  placement: 'Reels' | 'Video' | 'Profile';
  creatorId?: string;
  postId?: string;
  /** Chủ bài (nếu biết) để không hiện quảng cáo cho chính creator. */
  ownerId?: string;
  variant?: 'card' | 'reel';
  initialAd?: AdCreative;
}

const same = (a?: string, b?: string) => !!a && !!b && a.toLowerCase() === b.toLowerCase();

/**
 * Thẻ quảng cáo trên trang cá nhân, video và Reel. Máy chủ quyết định có quảng cáo hay không, kể cả với khách
 * chưa đăng nhập (mảng rỗng thì không hiện gì). Chủ nội dung xem nội dung của chính mình thì không hiện.
 */
const CreatorAdCard: React.FC<CreatorAdCardProps> = ({
  placement,
  creatorId,
  postId,
  ownerId,
  variant = 'card',
  initialAd,
}) => {
  const viewerId = useSelector((s: RootState) => s.features.auth.profile?.userId);
  if (same(viewerId, creatorId) || same(viewerId, ownerId)) return null;
  // Đổi người xem (khách đăng nhập không tải lại trang) thì dựng lại thẻ để serve lại, vé phục vụ gắn đúng người xem mới.
  // useSelector ở trên làm thẻ vẽ lại khi hồ sơ đổi, lúc đó đọc lại khoá.
  return (
    <NativeAdCard
      key={adViewerKey()}
      placement={placement}
      creatorId={creatorId}
      postId={postId}
      variant={variant}
      initialAd={initialAd}
    />
  );
};

export default CreatorAdCard;
